export default __webpack_public_path__ + "static/media/experiences.c56521a1.svg";